module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-navigation"
  }, [_c('div', {
    staticClass: "c-navigation__aux-nav t-navigation-aux",
    class: {
      'is-hidden-on-desktop': _vm.hideAuxNavOnDesktop
    }
  }, [_c('div', {
    staticClass: "c-navigation__aux-nav__inner"
  }, [(_vm.backButton) ? _c('button', {
    staticClass: "c-navigation__aux-nav__button t-navigation-aux__button",
    on: {
      "click": function($event) {
        return _vm.historyBack()
      }
    }
  }, [_c('span', {
    staticClass: "c-navigation__aux-nav__button__icon fa fa-2x fa-chevron-left"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "c-navigation__aux-nav__name"
  }, [_vm._v(_vm._s(_vm.spaceName))])])]), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "c-navigation__main-nav t-navigation qa-main-nav",
    on: {
      "click": function($event) {
        return _vm.togglePointsLedger(false)
      }
    }
  }, [_c('div', {
    staticClass: "c-navigation__main-nav__inner"
  }, [_vm._l((_vm.websiteConfig.left_nav_menu), function(item, index) {
    return [(item.linkType == 'external') ? _c('a', {
      key: index,
      staticClass: "c-navigation__main-nav__link t-navigation__item qa-nav-link",
      attrs: {
        "href": item.url,
        "target": item.target
      }
    }, [_c('i', {
      class: 'c-navigation__main-nav__link__icon ' + item.icon + ' fa-2x'
    }), _vm._v(" "), _c('span', {
      staticClass: "c-navigation__main-nav__link__text"
    }, [_vm._v(_vm._s(item.text))])]) : (_vm.isVisible(item)) ? _c('router-link', {
      key: index,
      staticClass: "c-navigation__main-nav__link t-navigation__item qa-nav-link",
      attrs: {
        "active-class": "t-navigation__item--active",
        "target": item.target,
        "to": _vm.getRouteTo(item)
      }
    }, [_c('i', {
      class: 'c-navigation__main-nav__link__icon ' + item.icon + ' fa-2x'
    }), _vm._v(" "), _c('span', {
      staticClass: "c-navigation__main-nav__link__text"
    }, [_vm._v(_vm._s(item.text))])]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('router-link', {
    staticClass: "c-navigation__logo",
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.platformImages.navigation_logo_110,
      "alt": _vm.$t('web.app_navigation.alt_text_logo'),
      "srcset": _vm.platformImages.navigation_logo_110 + ' 110w, ' + _vm.platformImages.navigation_logo_160 + ' 160w, ' +
        _vm.platformImages.navigation_logo_220 + ' 220w, ' + _vm.platformImages.navigation_logo_320 + ' 320w'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "c-navigation__points-indicator"
  }, [(_vm.isLoggedIn) ? _c('a', {
    staticClass: "c-navigation__points-indicator__link t-points-indicator js-points-ledger-trigger",
    on: {
      "click": function($event) {
        return _vm.togglePointsLedger(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star t-points-indicator__icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "t-points-indicator__text"
  }, [_vm._v(_vm._s(typeof _vm.participant !== 'undefined' ? _vm.formatNumber(_vm.participant.points_balance) : ''))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('points-ledger') : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn) ? _c('div', {
    staticClass: "c-navigation__public t-navigation"
  }, [_c('div', {
    staticClass: "c-navigation__public__inner"
  }, [_c('h1', [_c('router-link', {
    staticClass: "c-navigation__public__platform-name t-navigation-aux__text",
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v(_vm._s(_vm.websiteConfig.name))])], 1), _vm._v(" "), (_vm.websiteConfig.enrollment_enabled) ? _c('router-link', {
    staticClass: "c-navigation__public__link t-navigation-aux__text",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.app_navigation.signup_link')) + "\n      ")]) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-959131e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/AppNavigation.vue
// module id = 559
// module chunks = 1